import {ROLES} from '../constants/allConstants';

const COMPANY_ELEMENTS = {
  companyInfo: 'companyInfoView',
  financeInfoView: 'financeInfoView',
  financeInfoEdit: 'financeInfoEdit',
  editPaymentMethod: 'editPaymentMethod',
  companySettings: 'companySettings',
  companySettingsEdit: 'companySettingsEdit',
  ownerInfo: 'ownerInfo',
  workersInfo: 'workersInfo',
  serviceTitanInfo: 'serviceTitanInfo',      // Thanh 01/04/24
  invoiceInfo: 'invoiceInfo',      // Thanh 01/04/24
  tagsInfo: 'tags',
  inspectionInfo: 'inspectionInfo',
  serviceTitanEmp: 'serviceTitanEmp',
  serviceTitanNotEmp: 'serviceTitanNotEmp',
  serviceTitanJob: 'serviceTitanJob',
  inviteButton: 'inviteButton',
  editButton: 'editButton',
  inviteCompany: 'inviteCompany',
  editStatus: 'editStatus',
  impersonate: 'impersonate',
  depersonateButton: 'depersonateButton',
  verify: 'verify',
  allCompaniesNavLink: 'allCompaniesLink',
  companyNavLink: 'companyNavLink',
  notesInfo: 'notesInfo',
  editInspInfo: 'editInspInfo',
};

const companyPolicies = {
  modify: 'company.modify',
  verify: 'company.verify',
  manageState: 'company.manageState',
  impersonate: 'company.impersonate',
  viewFinance: 'company.viewFinance',
  editFinance: 'company.editFinance',
  editInspInfo: 'company.editInspInfo',
};

const contractorCompanyRules = Object.freeze({
  [COMPANY_ELEMENTS.companyInfo]: [ROLES.COMPANY_ADMIN, ROLES.CONTRACTOR],
  [COMPANY_ELEMENTS.ownerInfo]:[ROLES.COMPANY_ADMIN],
  [COMPANY_ELEMENTS.workersInfo]: [ROLES.COMPANY_ADMIN, ROLES.CONTRACTOR],
  [COMPANY_ELEMENTS.serviceTitanInfo]: [ROLES.COMPANY_ADMIN],    // Thanh 01/04/24
  [COMPANY_ELEMENTS.invoiceInfo]: [ROLES.COMPANY_ADMIN],    // Update by Ubaid 03/17/26
  [COMPANY_ELEMENTS.tagsInfo]: [ROLES.COMPANY_ADMIN],
  [COMPANY_ELEMENTS.inspectionInfo]: [ROLES.COMPANY_ADMIN],
  [COMPANY_ELEMENTS.serviceTitanEmp]: [ROLES.COMPANY_ADMIN],   
  [COMPANY_ELEMENTS.serviceTitanNotEmp]: [ROLES.COMPANY_ADMIN],   
  [COMPANY_ELEMENTS.serviceTitanJob]: [ROLES.COMPANY_ADMIN],  
  [COMPANY_ELEMENTS.editButton]: [ROLES.COMPANY_ADMIN],
  [COMPANY_ELEMENTS.companyNavLink]: [ROLES.COMPANY_ADMIN, ROLES.CONTRACTOR],
  [COMPANY_ELEMENTS.editPaymentMethod]: [ROLES.COMPANY_ADMIN],
  [COMPANY_ELEMENTS.notesInfo]: [ROLES.IPERMIT_ADMIN],
});

const companyRules = Object.freeze({
  [COMPANY_ELEMENTS.companyInfo]: {
    policyName: undefined,
    contractorAccess: true,
    contractorPermissions: contractorCompanyRules[COMPANY_ELEMENTS.companyInfo],
  },
  [COMPANY_ELEMENTS.ownerInfo]: {
    policyName: undefined,
    contractorAccess: true,
    contractorPermissions: contractorCompanyRules[COMPANY_ELEMENTS.ownerInfo],
  },
  [COMPANY_ELEMENTS.workersInfo]: {
    policyName: undefined,
    contractorAccess: true,
    contractorPermissions: contractorCompanyRules[COMPANY_ELEMENTS.workersInfo],
  },
  [COMPANY_ELEMENTS.serviceTitanInfo]: {
    policyName: undefined,
    contractorAccess: true,
    contractorPermissions: contractorCompanyRules[COMPANY_ELEMENTS.serviceTitanInfo],
  },
  [COMPANY_ELEMENTS.invoiceInfo]: {
    policyName: undefined,
    contractorAccess: true,
    contractorPermissions: contractorCompanyRules[COMPANY_ELEMENTS.invoiceInfo],
  },
  [COMPANY_ELEMENTS.tagsInfo]: {
    policyName: undefined,
    contractorAccess: true,
    contractorPermissions: contractorCompanyRules[COMPANY_ELEMENTS.tagsInfo],
  },
  [COMPANY_ELEMENTS.inspectionInfo]: {
    policyName: undefined,
    contractorAccess: true,
    contractorPermissions: contractorCompanyRules[COMPANY_ELEMENTS.inspectionInfo],
  },
  [COMPANY_ELEMENTS.serviceTitanEmp]: {
    policyName: undefined,
    contractorAccess: true,
    contractorPermissions: contractorCompanyRules[COMPANY_ELEMENTS.serviceTitanEmp],
  },
  [COMPANY_ELEMENTS.serviceTitanNotEmp]: {
    policyName: undefined,
    contractorAccess: true,
    contractorPermissions: contractorCompanyRules[COMPANY_ELEMENTS.serviceTitanNotEmp],
  },
  [COMPANY_ELEMENTS.serviceTitanJob]: {
    policyName: undefined,
    contractorAccess: true,
    contractorPermissions: contractorCompanyRules[COMPANY_ELEMENTS.serviceTitanJob],
  },
  [COMPANY_ELEMENTS.editButton]: {
    policyName: companyPolicies.modify,
    contractorAccess: true,
    contractorPermissions: contractorCompanyRules[COMPANY_ELEMENTS.editButton],
  },
  [COMPANY_ELEMENTS.inviteCompany]: {
    policyName: companyPolicies.modify,
    contractorAccess: false,
  },
  [COMPANY_ELEMENTS.financeInfoView]: {
    policyName: companyPolicies.viewFinance,
    contractorAccess: false,
  },
  [COMPANY_ELEMENTS.financeInfoEdit]: {
    policyName: companyPolicies.editFinance,
    contractorAccess: false,
  },
  [COMPANY_ELEMENTS.editInspInfo]: {            
    policyName: companyPolicies.editInspInfo,
    contractorAccess: false,
  },
  [COMPANY_ELEMENTS.companySettings]: {
    policyName: undefined,
    contractorAccess: false,
    hideWhenImpersonating: true,
  },
  [COMPANY_ELEMENTS.companySettingsEdit]: {
    policyName: companyPolicies.modify,
    contractorAccess: false,
  },
  [COMPANY_ELEMENTS.inviteButton]: {
    policyName: companyPolicies.modify,
    contractorAccess: false,
  },
  [COMPANY_ELEMENTS.editStatus]: {
    policyName: companyPolicies.manageState,
    contractorAccess: false,
  },

  [COMPANY_ELEMENTS.impersonate]: {
    policyName: companyPolicies.impersonate,
    contractorAccess: false,
    hideWhenImpersonating: true,
  },

  [COMPANY_ELEMENTS.depersonateButton]: {
    policyName: companyPolicies.impersonate,
  },

  [COMPANY_ELEMENTS.verify]: {
    policyName: companyPolicies.verify,
    contractorAccess: false,
  },
  [COMPANY_ELEMENTS.allCompaniesNavLink]: {
    policyName: undefined,
    contractorAccess: false,
    hideWhenImpersonating: true,
  },
  [COMPANY_ELEMENTS.companyNavLink]: {
    policyName: undefined,
    contractorAccess: true,
    contractorPermissions: contractorCompanyRules[COMPANY_ELEMENTS.companyNavLink],
  },
  [COMPANY_ELEMENTS.editPaymentMethod]: {
    policyName: companyPolicies.editFinance,
    contractorAccess: true,
    contractorPermissions: contractorCompanyRules[COMPANY_ELEMENTS.editPaymentMethod],
  },
  [COMPANY_ELEMENTS.notesInfo]: {
    policyName: companyPolicies.impersonate,
    contractorAccess: false,
    hideWhenImpersonating: true,
  }

});

export {companyRules, COMPANY_ELEMENTS};
